import { Injectable } from '@angular/core';
import { AnimationBuilder, style, animate } from '@angular/animations';

@Injectable({
  providedIn: 'root'
})

export class CoreAnimation {

  constructor(protected builder: AnimationBuilder) { }

  wheelAnimation(element: string, duration: number, begin: {}, end: {}): void {
    const animation = this.builder.build([
      style(begin),
      animate(duration, style(end))
    ]);
    const player = animation.create(element);
    player.play();
  }

  smallToHigh(element: string, duration: number, begin: {}, end: {}): void {
    const animation = this.builder.build([
      style(begin),
      animate(duration, style(end))
    ]);
    const player = animation.create(element);
    player.play();
  }
}
